<template>
	<md-button class="md-primary" @click="redirectToTCIActivationPage">
		<i class="fa fa-shield secondary_color" aria-hidden="true" style="margin-bottom: -3px"></i>
		{{ $t("investor.exchange.table.button.activateTCI") }}
	</md-button>
</template>

<script>

import {navigationUtils} from "@/common/navigation/navigationUtils";
import {navigationPaths} from "@/common/navigation/navigationPaths";
import {navigationTabs} from "@/common/navigation/navigationTabs";

export default {
	methods: {
		redirectToTCIActivationPage() {
			this.$router.push(navigationUtils.getRouteWithActiveTab(navigationPaths.admin.company, navigationTabs.admin.company.tciActivation));
		},
	}
};
</script>